import { createContext, useContext } from 'react'

import { DEFAULT_ORDER_FORM } from '../constants'
import type { Context, OrderForm } from '../typings'

const noop = () => {}

export const OrderFormContext = createContext<Context<OrderForm>>({
  orderForm: DEFAULT_ORDER_FORM,
  setOrderForm: noop,
  error: undefined,
  loading: false,
})

export function useOrderForm<
  O extends OrderForm = typeof DEFAULT_ORDER_FORM
>() {
  const context = useContext(OrderFormContext)

  if (context === undefined) {
    throw new Error('useOrderForm must be used within a OrderFormProvider')
  }

  return context as Context<O>
}
